import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {config } from "../../api/config.js";
const apiUrl = process.env.REACT_APP_URL;

// add new card
export const addNewCard = createAsyncThunk(
  "pcard/add",
  async (card, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.post(`${apiUrl}/pcard/add`, card,config);
      if (res.status === 201) {
        return res.data.card;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// update card
export const updatePCard = createAsyncThunk(
  "pcard/update",
  async (payload, thunkApi) => {
    const { rejectWithValue } = thunkApi;
     const {id,values} = payload; 
    try {
      const res = await axios.put(`${apiUrl}/pcard/update/${id}`,values,config);
      if (res.status === 200) {
        return res.data.card;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// delete card
export const deleletePcard = createAsyncThunk(
  "pcard/delete",
  async (id, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.delete(`${apiUrl}/pcard/delete/${id}`,config);
      if (res.status === 200) {
        return res.data.id;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// get card
export const getCard = createAsyncThunk(
  "pcard/fetchOne",
  async (id, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.get(`${apiUrl}/pcard/fetchOne?id=${id}`,config );
      if (res.status === 200) {
        return res.data.card;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// get user card
export const getUserCard = createAsyncThunk(
  "pcard/fetchusercard",
  async (payload, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const {UUID,branch} = payload;
    try {
      const res = await axios.get(`${apiUrl}/pcard/fetchusercard?UUID=${UUID}&branch=${branch}`);
      if (res.status === 200) {
        return res.data.card;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// fetch cards
export const getCards = createAsyncThunk(
  "pcard/fetch",
  async (filter, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    const {startDate , endDate , employee,paymentType} = filter;
    try {
       const res = await axios.get(`${apiUrl}/pcard/fetch?startDate=${startDate}&endDate=${endDate}&paymentType=${paymentType}&employee=${employee}`,config);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);
// get serial bussiness card for branch 
export const getBussinesCradSerial = createAsyncThunk(
  "pcard/branchserial",
  async (branch, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const res = await axios.get(`${apiUrl}/pcard/branchserial?branch=${branch}`,config);
      if (res.status === 200) {
        return res.data.serial;
      }
    } catch (error) {
      return rejectWithValue(error.response.data.msg);
    }
  }
);


